export default __webpack_public_path__ + "static/media/Bradley.e17b168d.woff2";